<template>
	<el-dialog title="收藏用户列表" :visible.sync="visible" :close-on-click-modal="false" append-to-body width="1000px"
		top="8vh" center @close="closeDialog">
		<div class="admin-project-myproject-container scrollElement" style="height: 68vh;">
			<el-form :inline="true" :model="elevatorInfoSearch" class="demo-form-inline">
				<el-form-item label="人员名称">
					<el-input v-model="elevatorInfoSearch.userName" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="elevatorInfoSearch.phone" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="searchelevatorInfo" class="searchBtn">搜索</el-button>
					<el-button type="warning" @click="reset">重置</el-button>
				</el-form-item>
			</el-form>
			<div class="dataList">
				<el-table :data="elevatorInfoData" ref="multipleTable" border max-height="500px" style="width: 100%;">
					<el-table-column type="index" align='center' label="编号" width="100px" />
					<el-table-column prop="userName" align='center' label="人员名称" min-width="150px" />
					<el-table-column prop="phone" align='center' label="手机号" min-width="150px" />
					<el-table-column prop="createTime" align='center' label="最新收藏时间" min-width="150px" />
				</el-table>
				<Pagination :total="elevatorInfoTotal" :page.sync="elevatorInfoQuery.current"
					:limit.sync="elevatorInfoQuery.size" @pagination="elevatorInfoPage" />
			</div>
		</div><span slot="footer" class="dialog-footer">
		</span>
	</el-dialog>
</template>

<script>
	import Pagination from '../../../../components/Pagination'
	export default {
		components: {
			Pagination,
		},
		data() {
			return {
				dataId: null, // 合同id
				loading: true,
				visible: true,
				search: false,
				elevatorInfoData: [],
				elevatorInfoTotal: 0,
				elevatorInfoQuery: {
					current: 1,
					size: 10,
				},
				elevatorInfoSearch: {
					name: '',
				},
				addBrandCallback: null, // 弹窗回调
			}
		},

		methods: {
			// 电梯id，回调
			init(id, callback) {
				this.addBrandCallback = callback
				this.elevatorInfoSearch.name = ''
				this.visible = true
				this.loading = false
				this.dataId = id
				this.$nextTick(() => {
					this.getelevatorInfo()
				})
			},
			searchelevatorInfo() {
				this.elevatorInfoQuery.current = 1
				this.search = true
				this.getelevatorInfo()
			},
			// 重置
			reset() {
				
				this.search = false
				this.elevatorInfoSearch = {}
				this.elevatorInfoQuery = {
					current: 1,
					size: 10
				}
				this.getelevatorInfo()
			},

			// 分页
			elevatorInfoPage(data) {
				this.elevatorInfoQuery.current = data.page
				this.elevatorInfoQuery.size = data.limit
				this.getelevatorInfo()
			},

			// 获取列表
			getelevatorInfo() {
				const data = JSON.parse(JSON.stringify(this.elevatorInfoQuery))
				data.dataId = this.dataId
				if (this.search) {
					data.userName = this.elevatorInfoSearch.userName
					data.phone = this.elevatorInfoSearch.phone
				}
				this.$http
					.post('/api/base/data/collect/getDataCollectWebList', data)
					.then((res) => {
						if (res.data.code === 200) {
							const { data: { data } } = res
							this.elevatorInfoData = data.records ? JSON.parse(JSON.stringify(data.records)) : []
							this.elevatorInfoTotal = data.total ?? 0
							this.search = false
							this.$nextTick(() => {
								if (this.elevatorInfoTotal > 0 && this.$refs.multipleTable) {
									this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
								}
							})
						}
					})
			},
			closeDialog() {
				this.visible = false
                this.$emit('closeDialog')
			},
		},
	}
</script>
<style lang='scss' scoped>
	.searchBox {
		/deep/.el-form-item__label {
			color: #00f6ff !important;
			font-size: 14px;
		}

		.searchBtn {
			margin-left: 15px;
		}
	}
</style>
